<script setup>
import { computed, ref, watch } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useVideoStore } from '@/Stores/VideoStore'
import VideoPlayer from '@/Components/VideoPlayer/VideoPlayer.vue'

const videoStore = useVideoStore();
const settings = ref(usePage().props.settings);
const gorse = ref(usePage().props.gorse);
const player = ref(null);
const videoState = ref(null);
const viewed = ref(false);
const watched = ref(false);

const props = defineProps({
	source: { type: Object, required: true },
	poster: { type: String },
	post: { type: Object, required: true },
	isActive: { type: Boolean, default: false },
	showProgress: { type: Boolean, default: true },
});

const emit = defineEmits(['ended', 'ad-playing']);

// Update video store when active changes
watch(() => props.isActive, (active) => {
	if (!player.value) return;

	if (active) {
		videoStore.setCurrentVideo(player.value);
	} else {
		player.value.pause();
		player.value.resetAdState();
	}
}, { immediate: false });

const onPlayerMounted = (payload) => {
	videoState.value = payload?.state;

	// Set current video if it's the active post
	if (props.isActive && player.value) {
		videoStore.setCurrentVideo(player.value);
	}
}

const onPlayerTimeUpdate = (payload) => {
	if (!payload || !payload.state || !props.post || !gorse.value.enabled) return;

	const { currentTime, duration } = payload.state;
	videoState.value = payload.state;

	if (duration > 0) {
		let completed = Math.round((currentTime / duration) * 100);

		if (!viewed.value && completed >= 2) {
			window.axios.post(route('post.feedback', {post: props.post.uuid, feedback: 'view'}));
			viewed.value = true;
		}

		if (!watched.value && completed >= 70) {
			window.axios.post(route('post.feedback', {post: props.post.uuid, feedback: 'watch'}));
			watched.value = true;
		}
	}
}

const onVideoEnded = () => {
	emit('ended');
}

const handleAdPlaying = (status) => {
	emit('ad-playing', status);
}
</script>

<template>
	<div class="w-full h-full">
		<VideoPlayer
			ref="player"
			:source="source"
			:poster="poster"
			:autoplay="isActive"
			:loop="settings.loop"
			:playsinline="true"
			:preload="'auto'"
			:is-active="isActive"
			:vast-url="settings.vast_url"
			:ad-frequency="settings.vast_ad_frequency"
			:orientation="post.orientation || 'vertical'"
			:show-progress="showProgress"
			class="w-full h-full"
			@mounted="onPlayerMounted"
			@ended="onVideoEnded"
			@timeupdate="onPlayerTimeUpdate"
			@ad-started="handleAdPlaying(true)"
			@ad-ended="handleAdPlaying(false)"
		/>
	</div>
</template>

<style>
/* Removed hardcoded object-fit to allow dynamic control based on video aspect ratio */
</style>
